import { useState } from "react";
import {
    Wallet,
    Heart,
    Download,
    Gift,
    Upload,
    CreditCard,
    ArrowRightLeft,
    PlusCircle,
    MinusCircle,
    ChevronDown,
    Settings,
    Menu,
    X,
    ShoppingBag,
    BadgeHelp,
    MessageCircleHeart,
     Box,
    Figma,


} from "lucide-react";



const navGroups = [
    {
        label: "Wallet",
        icon: Wallet,
        items: [
            { key: "wallet", icon: Wallet, label: "Wallet Overview" },
            { key: "wishlist", icon: Heart, label: "Wishlist Manager" }
        ]
    },{
        label: "Purchases",
        icon: ShoppingBag,
        items: [
            { key: "purchases", icon: ShoppingBag, label: "Purchases" },
            { key: "supportTickets", icon: BadgeHelp, label: "Support Tickets" },

        ]
    },{
        label: "Digitals",
        icon: ShoppingBag,
        items: [
            { key: "templatesDashboardAnalytics", icon: Figma, label: "Temps & Digitals" },
            { key: "digitals", icon: Figma, label: "Digitals" },
            { key: "templates", icon: Figma, label: "Templates" },

        ]
    },{
        label: "Ads",
        icon: Gift,
        items: [
            { key: "createAd", icon: Gift, label: "Advertisements" },
            { key: "adlist", icon: Gift, label: "Ad List" },
            { key: "dashboardAds", icon: Gift, label: "Analytics" },

        ]
    },
    {
        label: "Transactions",
        icon: ArrowRightLeft,
        items: [
            { key: "deposits", icon: Download, label: "Deposits History" },
            { key: "depositFunds", icon: PlusCircle, label: "New Deposit" },
            { key: "withdrawals", icon: Upload, label: "Withdrawals Log" },
            { key: "withdrawalRequest", icon: MinusCircle, label: "Withdrawal Req" }
        ]
    },{
        label: "Miscellaneous",
        icon: ArrowRightLeft,
        items: [
            { key: "userFeedBack", icon: MessageCircleHeart, label: "FeedBack" },
            { key: "availableServices", icon: Box, label: "Services" },
            { key: "templateSuggestions", icon: Box, label: "Suggestions" },
            { key: "contactForm", icon: Box, label: "Contact Subs" },
        ]
    },
    {
        label: "Rewards",
        icon: Gift,
        items: [
            { key: "rewards", icon: Gift, label: "Rewards Catalog" },
            { key: "transferRewards", icon: ArrowRightLeft, label: "Rewards Transfer" },
            { key: "referrals", icon: ArrowRightLeft, label: "Referrals" }
        ]
    },
    {
        label: "Settings",
        icon: Settings,
        items: [
            { key: "paymentAccounts", icon: CreditCard, label: "Payment Meth." },
            { key: "profile", icon: CreditCard, label: "Profile" },
        ],
    }
];

export default function Sidebar({ onNavigate }: { onNavigate: (key: string) => void }) {
    const [openSections, setOpenSections] = useState<{ [key: string]: boolean }>({});
    const [isMobileOpen, setIsMobileOpen] = useState(false);

    const toggleSection = (label: string) => {
        setOpenSections((prev) => ({ ...prev, [label]: !prev[label] }));
    };

    return (
        <>
            {/* Botón de hamburguesa en móviles */}
            <button
                onClick={() => setIsMobileOpen(!isMobileOpen)}
                className="md:hidden fixed top-20 right-4 z-50 p-2 bg-white shadow rounded-full"
            >
                {isMobileOpen ? <X size={24} /> : <Menu size={24} />}
            </button>

            {/* Sidebar con visibilidad controlada en móviles */}
            <aside
                className={`w-64 bg-gradient-to-b from-slate-50 to-indigo-50 z-50 p-4 flex flex-col h-screen border-r border-indigo-100
        fixed md:relative top-0 left-0 transition-transform duration-300
        ${isMobileOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
            >
                <h1 className="text-2xl font-bold mb-6 text-indigo-900 pl-2">
                    <span className="bg-navy-900 bg-clip-text text-transparent">Finance Portal</span>
                </h1>
                <nav className="flex-1 overflow-y-auto pr-2 space-y-3">
                    {navGroups.map((group) => {
                        const GroupIcon = group.icon;
                        return (
                            <div key={group.label} className="group">
                                <button
                                    onClick={() => toggleSection(group.label)}
                                    className="flex justify-between items-center w-full px-4 py-3 text-left bg-white/80 backdrop-blur-sm
                      rounded-xl hover:bg-white transition-all duration-200 shadow-sm hover:shadow-md
                      border border-indigo-50 hover:border-indigo-100"
                                >
                                    <div className="flex items-center space-x-3">
                                        <GroupIcon size={20} className="text-indigo-600" />
                                        <span className="font-semibold text-indigo-900">{group.label}</span>
                                    </div>
                                    <ChevronDown
                                        size={18}
                                        className={`transition-transform duration-200 text-indigo-400 ${
                                            openSections[group.label] ? "rotate-180" : ""
                                        }`}
                                    />
                                </button>
                                <div
                                    className={`${
                                        openSections[group.label] ? "block" : "hidden"
                                    } mt-2 ml-6 border-l-2 border-indigo-100 pl-4 space-y-2`}
                                >
                                    {group.items.map((item) => {
                                        const Icon = item.icon;
                                        return (
                                            <button
                                                key={item.key}
                                                onClick={() => {
                                                    onNavigate(item.key);
                                                    setIsMobileOpen(false); // Cierra el menú en móviles al navegar
                                                }}
                                                className="flex w-full items-center space-x-3 px-3 py-2.5
                            text-indigo-700 hover:text-indigo-900 hover:bg-indigo-50
                            rounded-lg transition-colors duration-200"
                                            >
                                                <Icon size={18} className="text-indigo-500" />
                                                <span className="text-sm font-medium">{item.label}</span>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </nav>
            </aside>
        </>
    );
}
